import React, { useEffect } from "react";
import { FaSignOutAlt, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./MenuModal.css";
import { NavIcon, pathFor } from "./navigation";

export default function MenuModal({ groups, onClose, onLogout, currentPath }) {
  const navigate = useNavigate();

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="menu-modal" onClick={onClose}>
      <div className="menu-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="menu-modal-header">
          <div>
            <h2>Snel naar</h2>
            <p>Kies een onderdeel om direct te openen.</p>
          </div>
          <button className="close-btn" type="button" onClick={onClose} title="Sluiten">
            <FaTimes />
          </button>
        </div>

        {groups.map((group) => (
          <section key={group.key} className="menu-modal-group">
            <h3>{group.label}</h3>
            <div className="tiles-grid">
              {group.items.map((item) => {
                const path = pathFor(item.key);
                return (
                  <button
                    type="button"
                    key={item.key}
                    className={`menu-tile ${currentPath === path ? "active" : ""}`}
                    onClick={() => { navigate(path); onClose(); }}
                  >
                    <NavIcon item={item} className="tile-icon" />
                    <span className="tile-label">{item.label}</span>
                  </button>
                );
              })}
            </div>
          </section>
        ))}

        <div className="menu-modal-footer">
          <button type="button" className="logout-tile" onClick={() => { onClose(); onLogout(); }}>
            <FaSignOutAlt /> Uitloggen
          </button>
        </div>
      </div>
    </div>
  );
}
